import {
  ActivityIndicator,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import React, { memo, useEffect, useState } from "react";
import Svg, { Circle, Path } from "react-native-svg";
import {
  applyCoupon,
  getOrderSummary,
  removeCoupon,
} from "appRedux/reducers/orderSlice";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { router, useLocalSearchParams } from "expo-router";
import { setCart, updateCartProduct } from "appRedux/reducers/cartSlice";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Accordion from "components/Accordion";
import { Colors } from "colors";
import { CommonStyles } from "utils/CommonStyles";
import { DELIVERY_TYPE } from "utils/Constants";
import ImageView from "../../../src/image";
import SaleComponent from "components/PLP/SaleComponent";
import StepperButton from "components/PDP/StepperButton";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import moment from "moment";
import { trackV2 } from "utils/Segment";

const MAX_CART_QTY = 10;

const CheckoutCard = ({
  cartItem = {},
  hideOptions = false,
  containerStyle = {},
  hideCross = false,
  isOrderSummaryCall = false,
  deliveryType = "Standard Delivery",
  idx,
  shippingMethods = [],
  isInPopUp = false,
  sizeTextStyle = {},
}) => {
  const [removeLoading, setRemoveLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [chnageQtyLoading, setChnageQtyLoading] = useState(false);
  const [isDeliveryLoading, setIsDeliveryLoading] = useState(false);
  const [top, setTop] = useState(0);
  const [width, setWidth] = useState(0);

  const cartDataItems = useSelector((state) => state.CartReducer.cart);
  const orderSummary = useSelector((state) => state.OrderReducer.orderSummary);
  const userId = useSelector((state) => state.AuthReducer.userId);
  const deliveryAddress = useSelector(
    (state) => state.OrderReducer.deliveryAddress
  );
  const closeAccordians = useSelector(
    (state) => state.UtilsReducer.closeAccordians
  );
  const local = useLocalSearchParams();
  const gender = local?.gender || "female";
  const dispatch = useDispatch();
  const couponApplied = useSelector(
    (state) => state.OrderReducer.couponApplied
  );
  const rotate = useSharedValue(0);
  const countrySymbol = useSelector(
    (state) => state.StoredutilsSlice.countrySymbol
  );

  const animatedStyles = useAnimatedStyle(() => ({
    transform: [{ rotateZ: `${rotate.value}deg` }],
  }));

  useEffect(() => {
    if (closeAccordians) {
      setIsOpen((prev) => {
        rotate.value = withTiming(0);
        return false;
      });
    }
  }, [closeAccordians]);

  const removeFromCart = () => {
    if (removeLoading || chnageQtyLoading) {
      return;
    }
    setRemoveLoading(true);
    dispatch(
      updateCartProduct({
        productId: cartItem?.product?.id,
        quantity: 0,
      })
    )
      .then((res) => {
        setRemoveLoading(false);
        if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
          dispatch(setCart(res?.payload?.data));
          dispatch(removeCoupon());
        }
      })
      .catch((err) => {
        setRemoveLoading(false);
        console.log("err", err);
      });
  };

  const onPressMinusBtn = () => {
    if (removeLoading || chnageQtyLoading) {
      return;
    }
    setChnageQtyLoading(true);
    const eventData = {
      product_id: cartItem?.product?.id,
      product_name: cartItem?.product?.productName,
      new_quantity: cartItem?.quantity - 1,
      old_quantity: cartItem?.quantity,
      total_cart_value: cartDataItems?.orderSummary?.totalAmount,
    };
    trackV2(ANALYTICS_EVENT_NAMES.QUANTITY_UPDATED, eventData);
    if (cartItem?.quantity - 1 == 0) {
      const eventData = {
        product_id: cartItem?.product?.id,
        product_name: cartItem?.product?.productName,
        total_cart_value: cartDataItems?.orderSummary?.totalAmount,
      };
      trackV2(ANALYTICS_EVENT_NAMES.PRODUCT_REMOVED, eventData);
    }
    dispatch(
      updateCartProduct({
        productId: cartItem?.product?.id,
        quantity: cartItem?.quantity - 1,
        size: cartItem?.productSize,
      })
    )
      .then((res) => {
        setChnageQtyLoading(false);
        if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
          dispatch(setCart(res?.payload?.data));
          dispatch(removeCoupon());
        }
      })
      .catch((err) => {
        setChnageQtyLoading(false);
      });
  };

  const onPressPlusBtn = () => {
    if (cartItem?.quantity == MAX_CART_QTY) {
      return;
    }
    if (removeLoading || chnageQtyLoading) {
      return;
    }
    const eventData = {
      product_id: cartItem?.product?.id,
      product_name: cartItem?.product?.productName,
      new_quantity: cartItem?.quantity + 1,
      old_quantity: cartItem?.quantity,
      total_cart_value: cartDataItems?.orderSummary?.totalAmount,
    };
    trackV2(ANALYTICS_EVENT_NAMES.QUANTITY_UPDATED, eventData);

    setChnageQtyLoading(true);
    dispatch(
      updateCartProduct({
        productId: cartItem?.product?.id,
        quantity: cartItem?.quantity + 1,
        size: cartItem?.productSize,
      })
    )
      .then((res) => {
        setChnageQtyLoading(false);
        if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
          dispatch(setCart(res?.payload?.data));
          dispatch(removeCoupon());
        }
      })
      .catch((err) => {
        setChnageQtyLoading(false);
      });
  };

  const getEstimatedDeliveryDate = () => {
    const item = shippingMethods?.find((o) => o?.name == deliveryType);
    return moment(item?.estimatedDeliveryDate).format("DD, MMM YYYY");
  };

  const onPressDelivery = (delivery) => {
    setIsDeliveryLoading(true);
    dispatch(
      getOrderSummary({
        addressId: deliveryAddress?.id,
        products: cartDataItems?.cart
          ?.filter((o) => o?.isAvailable)
          ?.map((o) => {
            // Create a copy of the object and remove the shippingMethods key
            const { shippingMethods, selectedShippingMethod, ...rest } = o;
            let id = rest?.product?.id;
            let temp = { id: id, ...rest };
            // Find the corresponding product in orderSummary array
            const matchingProduct = orderSummary?.products?.find(
              (item) => item.productId === id
            );

            if (matchingProduct && id !== cartItem?.product?.id) {
              // Set selectedShippingMethod from orderSummary if available
              temp.selectedShippingMethod =
                matchingProduct.selectedShippingMethod?.name;
            } else if (id === cartItem?.product?.id) {
              temp.selectedShippingMethod = delivery;
            }
            delete temp.product;
            return temp;
          }),
        totalAmount: cartDataItems?.orderSummary?.totalAmount,
        userId: userId,
      })
    )
      .then((res) => {
        if (orderSummary?.coupons && Array.isArray(orderSummary?.coupons)) {
          let exists = orderSummary?.coupons?.find(
            (o) => o?.code?.toLowerCase() == couponApplied?.toLowerCase()
          );
          if (exists) {
            dispatch(applyCoupon(exists));
          }
        }
        setIsDeliveryLoading(false);
      })
      .catch((err) => {
        setIsDeliveryLoading(false);
        console.log("err", err);
      });
  };

  const isAvailable = cartItem?.regionAvailability;

  return (
    <View
      style={{
        zIndex: (idx + 1) * -10,
        flex: 1,
      }}
    >
      <View
        style={[
          {
            marginBottom: spV(16),
            backgroundColor: "white",
            zIndex: -100,
          },
        ]}
        onLayout={(data) => {
          setTop(data.nativeEvent.layout.height);
        }}
      >
        <View
          style={[
            {
              flexDirection: "row",
              zIndex: -100,
            },
            containerStyle,
          ]}
        >
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={() =>
              router.push(
                `${gender == "men" ? "/men" : ""}/product/${
                  cartItem?.product?.id
                }/${cartItem?.product?.brandName}/${
                  cartItem?.product?.productName
                }`?.replaceAll(" ", "-")
              )
            }
          >
            <ImageView
              style={{
                width: wp(111),
                marginRight: spH(16),
                height: hp(148),
                opacity: isAvailable === false ? 0.2 : 1,
              }}
              resizeMode={ImageView.resizeMode.contain}
              source={{ uri: cartItem?.product?.imageUrls?.[0] }}
            />
          </TouchableOpacity>
          <View
            style={{
              marginRight: spH(36),
              flex: 1,
            }}
          >
            {isAvailable === false && (
              <VText
                style={{
                  color: "red",
                  fontSize: fp(14),
                  fontWeight: "350",
                  marginBottom: spV(10),
                }}
                text={"Product unavailable in selected country"}
              />
            )}
            <VText
              style={{
                fontSize: fp(14),
                fontWeight: "550",
                lineHeight: "140%",
                paddingBottom: spV(4),
                opacity: isAvailable === false ? 0.2 : 1,
              }}
              text={cartItem?.product?.brandName?.toUpperCase()}
            />
            <VText
              style={{
                fontSize: fp(14),
                fontWeight: "350",
                lineHeight: "140%",
                marginBottom: spV(4),
                width: "100%",
                opacity: isAvailable === false ? 0.2 : 1,
              }}
              numberOfLines={2}
              text={cartItem?.product?.productName}
            />
            {!cartItem?.isAvailable && (
              <VText
                style={{
                  fontSize: fp(12),
                  lineHeight: fp(14),
                  fontWeight: "350",
                  marginVertical: spV(4),
                  color: "#FF0000",
                  opacity: isAvailable === false ? 0.2 : 1,
                }}
                text={"OUT OF STOCK"}
              />
            )}
            {cartItem?.product?.salePercentage &&
            cartItem?.product?.salePercentage > 0 ? (
              <SaleComponent
                originalPrice={cartItem?.product?.originalProductPrice}
                finalPrice={cartItem?.product?.productPrice}
                discountPercentage={cartItem?.product?.salePercentage}
                discountStyle={{
                  fontSize: fp(14),
                  fontWeight: "550",
                  lineHeight: "140%",
                }}
                finalPriceStyle={{
                  fontSize: fp(14),
                  fontWeight: "550",
                  lineHeight: "140%",
                }}
                originalPriceStyle={{
                  fontSize: fp(14),
                  fontWeight: "550",
                  lineHeight: "140%",
                }}
              />
            ) : (
              <VText
                text={`${countrySymbol}${getFormatedCurrency(
                  cartItem?.product?.productPrice
                )}`}
                style={{
                  fontSize: fp(14),
                  fontWeight: "550",
                  lineHeight: "140%",
                  marginBottom: spH(20),
                  opacity: isAvailable === false ? 0.2 : 1,
                }}
              />
            )}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                flex: 1,
                opacity: isAvailable === false ? 0.2 : 1,
              }}
            >
              <View style={sizeTextStyle}>
                <VText
                  style={[
                    {
                      fontSize: fp(14),
                      lineHeight: fp(24),
                      fontWeight: "350",
                    },
                  ]}
                  text={`Size: ${cartItem?.productSize}`}
                />
              </View>

              {!hideOptions && !isInPopUp && (
                <StepperButton
                  itemCount={cartItem?.quantity}
                  onPressMinusBtn={() => onPressMinusBtn()}
                  onPressPlusBtn={() => onPressPlusBtn()}
                  customStyle={{
                    height: hp(32),
                    width: wp(80),
                    minWidth: wp(80),
                    marginLeft: wp(16),
                  }}
                  svgIconsSize={16}
                  MAX_CART_QTY={MAX_CART_QTY}
                  loading={chnageQtyLoading}
                  countStyle={{
                    fontWeight: "350",
                  }}
                />
              )}
              {hideOptions && (
                <VText
                  style={{
                    fontSize: fp(14),
                    lineHeight: fp(24),
                    fontWeight: "350",
                    paddingLeft: spH(16),
                  }}
                  text={`Quantity: ${cartItem?.quantity}`}
                />
              )}
            </View>
            {!hideOptions && isInPopUp && (
              <StepperButton
                itemCount={cartItem?.quantity}
                onPressMinusBtn={() => onPressMinusBtn()}
                onPressPlusBtn={() => onPressPlusBtn()}
                customStyle={{
                  height: hp(40),
                  width: wp(80),
                  minWidth: wp(80),
                }}
                svgIconsSize={16}
                MAX_CART_QTY={MAX_CART_QTY}
                loading={chnageQtyLoading}
              />
            )}
          </View>
          {!hideCross && (
            <TouchableOpacity
              style={{
                position: "absolute",
                right: 0,
                top: 0,
              }}
              activeOpacity={0.8}
              onPress={() => {
                const eventData = {
                  product_id: cartItem?.product?.id,
                  product_name: cartItem?.product?.productName,
                  total_cart_value: cartDataItems?.orderSummary?.totalAmount,
                };
                trackV2(ANALYTICS_EVENT_NAMES.PRODUCT_REMOVED, eventData);
                removeFromCart();
              }}
            >
              {!removeLoading && (
                <Svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <Circle cx="10" cy="10" r="10" fill="#F7F7F7" />
                  <Path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.46941 9.99974L6.41992 13.0492L6.95025 13.5796L9.99974 10.5301L13.0492 13.5796L13.5796 13.0492L10.5301 9.99974L13.5796 6.95025L13.0492 6.41992L9.99974 9.46941L6.95026 6.41992L6.41993 6.95025L9.46941 9.99974Z"
                    fill="#212427"
                  />
                </Svg>
              )}
              {removeLoading && <ActivityIndicator />}
            </TouchableOpacity>
          )}
        </View>
        {isOrderSummaryCall && (
          <>
            <View style={[CommonStyles.rowDirection]}>
              <TouchableOpacity
                onPress={() => {
                  setIsOpen((prev) => {
                    if (prev == true) {
                      rotate.value = withTiming(0);
                      return false;
                    } else {
                      rotate.value = withTiming(180);
                      return true;
                    }
                  });
                }}
                onLayout={(data) => {
                  setWidth(data.nativeEvent.layout.width);
                }}
                activeOpacity={0.8}
                style={[
                  CommonStyles.rowDirection,
                  {
                    alignItems: "center",
                    padding: spH(14),
                    justifyContent: "space-between",
                    borderWidth: 1,
                    borderColor: "rgba(33, 36, 39, 1)",
                    minWidth: wp(200),
                    maxHeight: hp(40),
                  },
                ]}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10.5 4.61589C10.5 4.33974 10.2761 4.11589 10 4.11589C9.72386 4.11589 9.5 4.33974 9.5 4.61589V9.51988C9.5 9.97555 9.70713 10.4065 10.063 10.6912L13.5338 13.4679C13.7494 13.6404 14.0641 13.6054 14.2366 13.3898C14.4091 13.1741 14.3741 12.8595 14.1585 12.687L10.6877 9.91031C10.569 9.81542 10.5 9.67177 10.5 9.51988V4.61589Z"
                      fill="#212427"
                    />
                  </Svg>
                  {isDeliveryLoading && (
                    <ActivityIndicator
                      style={{
                        paddingLeft: spH(12),
                      }}
                    />
                  )}

                  {!isDeliveryLoading && (
                    <VText
                      style={{
                        color: "rgba(33, 36, 39, 1)",
                        fontSize: fp(16),
                        paddingLeft: spH(12),
                      }}
                    >
                      {shippingMethods?.find((o) => o?.name == deliveryType)
                        ?.displayName || "Standard Delivery"}
                    </VText>
                  )}
                </View>
                <Animated.View style={animatedStyles}>
                  <Svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                      fill="#212427"
                    />
                  </Svg>
                </Animated.View>
              </TouchableOpacity>
              <View
                style={{
                  padding: spH(14),
                }}
              >
                <VText style={styles.text}>
                  {"Delivery By "}
                  <VText style={styles.boldText}>
                    {getEstimatedDeliveryDate()}
                  </VText>
                </VText>
              </View>
            </View>
          </>
        )}
      </View>
      <Accordion
        viewKey="1234567890"
        style={{
          position: "absolute",
          zIndex: 999,
          elevation: 100,
          shadowColor: "rgba(0, 0, 0, 0.25)",
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 0.4,
          shadowRadius: 4,
          backgroundColor: "white",
          top: top,
          width: width,
        }}
        isExpanded={isOpen}
      >
        <View
          style={{
            paddingHorizontal: spH(24),
            paddingVertical: spV(24),
            shadowColor: "rgba(0, 0, 0, 0.25)",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.4,
            shadowRadius: 4,
            zIndex: 999,
            backgroundColor: "white",
          }}
        >
          {shippingMethods?.map((o, idx) => (
            <TouchableOpacity
              onPress={() => {
                onPressDelivery(o?.name);
                setIsOpen((prev) => {
                  rotate.value = withTiming(0);
                  return false;
                });
              }}
              key={idx}
              activeOpacity={0.8}
              style={{
                borderBottomWidth: idx == shippingMethods?.length - 1 ? 0 : 1,
                borderColor: "rgba(0, 0, 0, 0.16)",
                marginBottom: idx == shippingMethods?.length - 1 ? 0 : spV(16),
                paddingBottom: idx == shippingMethods?.length - 1 ? 0 : spV(12),
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <VText
                  style={{
                    fontSize: fp(16),
                    lineHeight: fp(24),
                  }}
                >
                  {o?.displayName}
                </VText>
                <View
                  style={{
                    width: wp(20),
                    height: wp(20),
                    borderRadius: 100,
                    borderWidth: 2,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {deliveryType == o?.name && (
                    <View
                      style={{
                        width: wp(8),
                        height: wp(8),
                        borderRadius: 100,
                        backgroundColor: "black",
                      }}
                    />
                  )}
                </View>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    width: wp(6),
                    height: wp(6),
                    borderRadius: 100,
                    backgroundColor: "rgba(217, 217, 217, 1)",
                    marginRight: spH(8),
                  }}
                />
                <VText
                  style={{
                    fontSize: fp(16),
                    lineHeight: fp(24),
                    color: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {`${o?.deliveryTimeline} to Ship`}
                </VText>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    width: wp(6),
                    height: wp(6),
                    borderRadius: 100,
                    backgroundColor: "rgba(217, 217, 217, 1)",
                    marginRight: spH(8),
                  }}
                />
                <VText
                  style={{
                    fontSize: fp(16),
                    lineHeight: fp(24),
                    color: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  {o?.cost == 0
                    ? "Standard Delivery Charges"
                    : `${countrySymbol}${o?.cost} Extra Delivery Charges`}
                </VText>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </Accordion>
    </View>
  );
};

export default memo(CheckoutCard);

const styles = StyleSheet.create({
  text: {
    color: Colors.black60,
    lineHeight: fp(24),
    fontSize: fp(16),
  },
  boldText: {
    color: Colors.black,
    lineHeight: fp(24),
    fontSize: fp(16),
    fontWeight: "550",
    display: "inline",
    // margin: spH(8),
  },
});
